import { useEntityConfigurationValueByKey } from "./useEntityConfiguration";

export function useIsCurationBreadcrumbsEnabled() {
    return useEntityConfigurationValueByKey("ENABLED_CURATION_BREADCRUMBS");
}
